import axios from './axios.js'

// 代币套餐
export function packageListData(limit, page, goodsTypeSonId,uids,orderNo,shopId,endDate,startDate) {
    return axios.get(`order_mall/list_data?limit=${limit}&page=${page}&goodsTypeSonId=${goodsTypeSonId}&userUid=${uids}&orderNo=${orderNo}&shopId=${shopId}&endDate=${endDate}&startDate=${startDate}`)
}
// 代币套餐查询
export function packageListDataSeach(limit, page, goodsTypeSonId,uids,orderNo,shopId,endDate,startDate) {
    return axios.get(`order_mall/list_data?limit=${limit}&page=${page}&goodsTypeSonId=${goodsTypeSonId}&userUid=${uids}&orderNo=${orderNo}&shopId=${shopId}&endDate=${endDate}&startDate=${startDate}`)
}

// 已支付订单
export function alreadyPay(limit, page, statusUser,uids,orderNo,shopId,endDate,startDate) {
    return axios.get(`order_mall/list_data?limit=${limit}&page=${page}&statusUser=${statusUser}&userUid=${uids}&orderNo=${orderNo}&shopId=${shopId}&endDate=${endDate}&startDate=${startDate}`)
}
// 已支付订单
export function alreadyPaySeach(limit, page, statusUser,uids,orderNo,shopId,endDate,startDate) {
    return axios.get(`order_mall/list_data?limit=${limit}&page=${page}&statusUser=${statusUser}&userUid=${uids}&orderNo=${orderNo}&shopId=${shopId}&endDate=${endDate}&startDate=${startDate}`)
}



// WEBPACK FOOTER //
// ./src/api/packageApi.js